var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowBox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 46,
  fill: "none",
  viewBox: "0 0 45 46"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 23,
  r: 21.5,
  stroke: "url(#a)",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M15 21.5a1 1 0 1 0 0 2v-2Zm14.707 1.707a1 1 0 0 0 0-1.414l-6.364-6.364a1 1 0 0 0-1.414 1.414l5.657 5.657-5.657 5.657a1 1 0 0 0 1.414 1.414l6.364-6.364ZM15 23.5h14v-2H15v2Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "a",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(146.537 19.13 11.93) scale(43.8274 54.8786)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3C071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B08421"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "matrix(-11.37503 .53703 -.06886 -1.4586 27.963 22.74)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3C071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B08421"
})))));
export { SvgArrowBox as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDUiIGhlaWdodD0iNDYiIHZpZXdCb3g9IjAgMCA0NSA0NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjIuNSIgY3k9IjIzIiByPSIyMS41IiBzdHJva2U9InVybCgjcGFpbnQwX3JhZGlhbF82MDFfMTk3KSIgc3Ryb2tlLXdpZHRoPSIyIi8+CjxwYXRoIGQ9Ik0xNSAyMS41QzE0LjQ0NzcgMjEuNSAxNCAyMS45NDc3IDE0IDIyLjVDMTQgMjMuMDUyMyAxNC40NDc3IDIzLjUgMTUgMjMuNVYyMS41Wk0yOS43MDcxIDIzLjIwNzFDMzAuMDk3NiAyMi44MTY2IDMwLjA5NzYgMjIuMTgzNCAyOS43MDcxIDIxLjc5MjlMMjMuMzQzMSAxNS40Mjg5QzIyLjk1MjYgMTUuMDM4NCAyMi4zMTk1IDE1LjAzODQgMjEuOTI4OSAxNS40Mjg5QzIxLjUzODQgMTUuODE5NSAyMS41Mzg0IDE2LjQ1MjYgMjEuOTI4OSAxNi44NDMxTDI3LjU4NTggMjIuNUwyMS45Mjg5IDI4LjE1NjlDMjEuNTM4NCAyOC41NDc0IDIxLjUzODQgMjkuMTgwNSAyMS45Mjg5IDI5LjU3MTFDMjIuMzE5NSAyOS45NjE2IDIyLjk1MjYgMjkuOTYxNiAyMy4zNDMxIDI5LjU3MTFMMjkuNzA3MSAyMy4yMDcxWk0xNSAyMy41SDI5VjIxLjVIMTVWMjMuNVoiIGZpbGw9InVybCgjcGFpbnQxX3JhZGlhbF82MDFfMTk3KSIvPgo8ZGVmcz4KPHJhZGlhbEdyYWRpZW50IGlkPSJwYWludDBfcmFkaWFsXzYwMV8xOTciIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDEuNjY2NyAxMS4zMzMzKSByb3RhdGUoMTQ2LjUzNykgc2NhbGUoNDMuODI3NCA1NC44Nzg2KSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFM0MwNzEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQjA4NDIxIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjxyYWRpYWxHcmFkaWVudCBpZD0icGFpbnQxX3JhZGlhbF82MDFfMTk3IiBjeD0iMCIgY3k9IjAiIHI9IjEiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiBncmFkaWVudFRyYW5zZm9ybT0idHJhbnNsYXRlKDI3Ljk2MyAyMi43NDA3KSByb3RhdGUoMTc3LjI5Nykgc2NhbGUoMTEuMzg3NyAxLjQ2MDIyKSI+CjxzdG9wIHN0b3AtY29sb3I9IiNFM0MwNzEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjQjA4NDIxIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";